import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'negativeToBracket',
    standalone: false
})
export class NegativeToBracket implements PipeTransform {
  constructor(private numberPipe: DecimalPipe) {}
  transform(value: any): any {
    return value = Number(value) ? value.toString().charAt(0) === '-'
      ? '(' + this.numberPipe.transform( value.toString().substring(1, value.length) ) + ')'
      : this.numberPipe.transform(value) : value;
  }
}
